/*** IMPORTS FROM imports-loader ***/
var define = false;

import Flickity from 'flickity';

export function bundlesSlider() {
  var slider = document.querySelector('.bundles__slider');
  var slides = slider.querySelectorAll('.bundles__slide');
  var flkty = null;
  var mobileQuery = window.matchMedia('(max-width: 959px)');

  function init() {
    // Always init on mobile, only on desktop if 4+ slides
    if (mobileQuery.matches || slides.length >= 4) {
      if (!flkty) {
        flkty = new Flickity(slider, {
          cellAlign: 'left',
          contain: true,
          wrapAround: false,
          prevNextButtons: true,
          pageDots: false,
          groupCells: true,
          on: {
            ready: function () {
              setTimeout(function () { flkty.resize(); }, 500);
            }
          }
        });
      }
    } else {
      if (flkty) {
        flkty.destroy();
        flkty = null;
      }
    }
  }

  init();
  mobileQuery.addEventListener('change', init);

  var tapArea = document.querySelectorAll('.bundles__slider');
  var startX = 0;
  for (var item of tapArea) {
    item.ontouchstart = function (e) {
      startX = e.touches[0].clientX;
    };
    item.ontouchmove = function (e) {
      if (Math.abs(e.touches[0].clientX - startX) > 5 && e.cancelable) {
        e.preventDefault();
      }
    };
  }
}

